import { render } from "./ApplicationLogo.vue?vue&type=template&id=8bee5f92"
const script = {}

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__